var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 3,
    rx: 12,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 8c-6.627 0-12-1.343-12-3v4c0 1.657 5.373 3 12 3s12-1.343 12-3v-4c0 1.657-5.373 3-12 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 14c-6.627 0-12-1.343-12-3v4c0 1.657 5.373 3 12 3s12-1.343 12-3v-4c0 1.657-5.373 3-12 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 20c-6.627 0-12-1.343-12-3v4c0 1.657 5.373 3 12 3s12-1.343 12-3v-4c0 1.657-5.373 3-12 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerStorage);
export default __webpack_public_path__ + "static/media/server-storage.b22c7dfb414db36736478962feb03870.svg";
export { ForwardRef as ReactComponent };